import React from "react";

const MenuIcon = ({ width = "auto", height = "auto", style = {} }) =>
    <svg role="img" viewBox="0 0 1080 720" style={{ ...style, width: width, height: height }}>
        <title>Menu icon</title>
        <g transform="matrix(1.03426,0,0,1.04255,-15.2173,-139.346)">
            <rect x="14.713" y="133.66" width="1044.22" height="115.103" />
        </g>
        <g transform="matrix(1.03426,0,0,1.04255,-15.2173,160.643)">
            <rect x="14.713" y="133.66" width="1044.22" height="115.103" />
        </g>
        <g transform="matrix(1.03426,0,0,1.04255,-15.2173,460.654)">
            <rect x="14.713" y="133.66" width="1044.22" height="115.103" />
        </g>
    </svg>;

export default MenuIcon;
